import { useEffect, useRef, type RefObject } from "react";

// Runs `cb` when the reveal observer dispatches `ns:play` on the element (data-play="…").
// The callback is kept in a ref so callers can pass inline closures without re-subscribing.
export function usePlay(ref: RefObject<HTMLElement | null>, cb: () => void): void {
  const cbRef = useRef(cb);
  useEffect(() => {
    cbRef.current = cb;
  });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const handler = () => cbRef.current();
    el.addEventListener("ns:play", handler);
    return () => el.removeEventListener("ns:play", handler);
  }, [ref]);
}
